import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useUser, UserButton } from '@clerk/clerk-react';

const AdminLayout: React.FC = () => {
  const { user } = useUser();
  const location = useLocation();

  const navItems = [
    { path: '/admin', label: 'Dashboard', icon: '📊' },
    { path: '/admin/posts', label: 'Posts', icon: '📝' },
    { path: '/admin/jobs', label: 'Jobs', icon: '💼' },
    { path: '/admin/companies', label: 'Companies', icon: '🏢' },
    { path: '/admin/targets', label: 'Sources', icon: '🎯' },
    { path: '/admin/scraper', label: 'Scraper', icon: '🔧' },
  ];

  const isActive = (path: string) => {
    if (path === '/admin') {
      return location.pathname === '/admin';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="min-h-screen bg-oak-900">
      {/* Header */}
      <header className="bg-oak-800 border-b border-oak-600/50">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Link to="/" className="flex items-center gap-2">
              <span className="text-xl">🏰</span>
              <span className="font-display font-bold text-amber-400">Guildhall</span>
            </Link>
            <span className="text-cream-200/50">|</span>
            <span className="text-cream-200/70 text-sm">Admin Dashboard</span>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-cream-200/70 text-sm">{user?.primaryEmailAddress?.emailAddress}</span>
            <UserButton />
          </div>
        </div>
      </header>

      <div className="flex">
        {/* Sidebar */}
        <aside className="w-64 bg-oak-800/50 min-h-[calc(100vh-57px)] border-r border-oak-600/50">
          <nav className="p-4">
            <ul className="space-y-1">
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`flex items-center gap-3 px-4 py-2 rounded-lg transition ${
                      isActive(item.path)
                        ? 'bg-amber-500/20 text-amber-400'
                        : 'text-cream-200/70 hover:bg-oak-700/50 hover:text-cream-100'
                    }`}
                  >
                    <span>{item.icon}</span>
                    <span>{item.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </aside>

        {/* Main content */}
        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
